// Service cards ("Safe and smart digital solutions") — the whole card follows its
// own "Learn more" button, so the card markup keeps a single real <a> inside.
export default function initServiceCardLinks() {
  const cards = document.querySelectorAll('.kd-service-card');

  if (!cards.length) return;

  cards.forEach((card) => {
    const cta = card.querySelector('.kd-service-card__cta a[href]');

    if (!cta) return;

    const href = cta.getAttribute('href');

    if (!href || href === '#') return;

    card.classList.add('is-linked');

    card.addEventListener('click', (event) => {
      // Real links/buttons inside the card keep their own behaviour, and a
      // click that ends a text selection shouldn't navigate.
      if (event.target.closest('a, button')) return;
      if (window.getSelection && String(window.getSelection())) return;

      if (event.metaKey || event.ctrlKey || cta.target === '_blank') {
        window.open(href, '_blank', 'noopener');
      } else {
        window.location.href = href;
      }
    });
  });
}
